    <span *ngIf="editing || editSingle">
      <input [id]="id" #inlineEditControl [size]="size" [required]="required" [name]="name" [(ngModel)]="value" [type]="type" [placeholder]="label" (blur)="onBlur()" [pattern]="pattern" (keydown)="onKeydown($event)"/>
    </span>
    <span *ngIf="!editing && !editSingle" (click)="startEdit()" style="min-width: 100px;min-height: 20px">
      {{value}}
    </span>
    <span *ngIf="!editSingle && (value=='' || value==undefined)" (click)="startEdit()">
      <i class="fa fa-pencil"></i>
    </span>
